import React, { useEffect, useState } from 'react';
import { injectIntl, useIntl } from 'react-intl';
import { connect, useSelector } from 'react-redux';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './SideMenu.css';
import cx from 'classnames';

// Component 
import Link from '../../Link';
import history from '../../../core/history';
import { getSideMenu } from '../../../helpers/getSideMenu';


const SideMenu = (props) => {
  const { showSideMenu } = props;
  const [location, setLocation] = useState(history.location || '')
  const isServicePlanEnabled = useSelector(state => state.siteSettings.data.isServicePlanEnabled);
  const { formatMessage } = useIntl();

  useEffect(()=>{
    if (history.location) {
      setLocation(history.location.pathname)
    }
  },[history.location])

  let sideMenuData = getSideMenu(showSideMenu, formatMessage);
  return (
    <>
      <ul className={cx('sideMenuBorder', 'listLayoutArbic')}>

        {sideMenuData
          .filter((item) => {
            if (item.menuLocation === '/users/service-plans/renter') {
              return isServicePlanEnabled == "true";
            }
            return true;
          })
          .map((item, index) => {
            return (
              <>
                <li className={cx('sideMenuBorderPadding', ((item.activeLocation.includes(location)) ? 'menuActive' : "menuNotActive"))}>
                  <Link to={item.menuLocation} className={cx('sideNavitem', 'sideNav')}>
                    <span className={cx('spaceLeft18')}>{item.menuName}</span>
                  </Link>
                </li>
              </>
            )
          })
        }
      </ul>
    </>
  )
}

export default injectIntl(withStyles(s)(SideMenu));